'use client';

import cx from 'classnames';
import React, { FC, useState } from 'react';

import { IListCases } from '@/contentful/utils/cases';

import PartCaseCard from './part-case-card';

import styles from './part-cases-container.module.scss';

interface IPartCasesContainerProps {
  lang: string;
  cases: IListCases[];
  full?: boolean;
}

const PartCasesContainer: FC<IPartCasesContainerProps> = ({
  cases,
  lang,
  full = true,
}) => {
  const [activeFilter, setActiveFilter] = useState<string | null>('All');

  const getUniqueFilters = (items: IListCases[]) => [
    ...new Set(items.flatMap((item: IListCases) => item.filter)),
  ];

  const uniqueFilters = getUniqueFilters(cases);
  uniqueFilters.unshift('All');

  const casesNav = uniqueFilters.map((item) => ({
    title: item,
    active: item === activeFilter,
  }));

  const handleFilterClick = (filterTitle: string) => {
    setActiveFilter(filterTitle);
  };

  const filteredCases = activeFilter === 'All'
    ? cases
    : cases.filter(
      (item) => activeFilter && item.filter.includes(activeFilter),
    );

  return (
    <>
      {casesNav && full && (
        <div className={styles.casesNavWrap}>
          <ul className={styles.casesNav}>
            {casesNav.map((item) => (
              <li key={item.title}>
                <button
                  type="button"
                  className={cx(styles.casesNavItem, {
                    [styles.active]: item.active,
                  })}
                  onClick={() => handleFilterClick(item.title)}
                >
                  <span>{item.title}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
      <ul className={styles.casesList}>
        {filteredCases.map((item) => (
          <li key={item.title} className={styles.casesItem}>
            <PartCaseCard caseData={item} lang={lang} />
          </li>
        ))}
      </ul>
    </>
  );
};

export default PartCasesContainer;
